import { render, staticRenderFns } from "./background.vue?vue&type=template&id=1cf1499c&scoped=true&lang=pug&"
import script from "./background.vue?vue&type=script&lang=js&"
export * from "./background.vue?vue&type=script&lang=js&"
import style0 from "./background.vue?vue&type=style&index=0&id=1cf1499c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1499c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cf1499c', component.options)
    } else {
      api.reload('1cf1499c', component.options)
    }
    module.hot.accept("./background.vue?vue&type=template&id=1cf1499c&scoped=true&lang=pug&", function () {
      api.rerender('1cf1499c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/background.vue"
export default component.exports